import api from '../api';
import axios from 'axios';

export default {
    CREATE: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.CREATE(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    LIST: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.LIST())
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_BY_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.GET_BY_ID(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATE: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.UPDATE(id), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    DELETE: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.DELETE(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_INBOX_OUTLOOK: (query, signal) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.GET_ALL_INBOX_OUTLOOK(query), { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    SEARCH_OUTLOOK: (query, signal) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.OutlookUser.SEARCH_OUTLOOK(query), { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
